/**
 * Constants for voice cloning options
 */

export const GENDER_OPTIONS = [
    { value: "male", labelKey: "male" },
    { value: "female", labelKey: "female" },
    { value: "neutral", labelKey: "neutral" },
];

export const LANGUAGE_OPTIONS = [
    { value: "en", labelKey: "english" },
    { value: "fr", labelKey: "french" },
    { value: "pt", labelKey: "portuguese" },
    { value: "ru", labelKey: "russian" },
    { value: "nl", labelKey: "dutch" },
    { value: "it", labelKey: "italian" },
    { value: "de", labelKey: "german" },
    { value: "es", labelKey: "spanish" },
    { value: "cn", labelKey: "chinese" },
    { value: "kr", labelKey: "korean" },
    { value: "jp", labelKey: "japanese" },
    { value: "ar", labelKey: "arabic" },
    { value: "pl", labelKey: "polish" },
    { value: "da", labelKey: "danish" },
    { value: "he", labelKey: "hebrew" },
    { value: "no", labelKey: "norwegian" },
    { value: "sv", labelKey: "swedish" },
    { value: "gr", labelKey: "greek" },
];

// ADD MANUALLY THE ACCENTS FOR EACH LANGUAGE
export const ACCENT_OPTIONS_BY_LANGUAGE: Record<string, Array<{ value: string; labelKey: string }>> = {
    en: [
        { value: "en-american", labelKey: "american" },
        { value: "en-australian", labelKey: "australian" },
        { value: "en-british", labelKey: "british" },
        { value: "en-canadian", labelKey: "canadian" },
        { value: "en-indian", labelKey: "indian" },
        { value: "en-irish", labelKey: "irish" },
        { value: "en-jamaican", labelKey: "jamaican" },
        { value: "en-new-zealand", labelKey: "newZealand" },
        { value: "en-nigerian", labelKey: "nigerian" },
        { value: "en-scottish", labelKey: "scottish" },
        { value: "en-south-african", labelKey: "southAfrican" },
    ],
    fr: [
        { value: "fr-acadian", labelKey: "acadian" },
        { value: "fr-african", labelKey: "african" },
        { value: "fr-belgian", labelKey: "belgian" },
        { value: "fr-cajun", labelKey: "cajun" },
        { value: "fr-creole", labelKey: "creole" },
        { value: "fr-meridional", labelKey: "meridional" },
        { value: "fr-parisian", labelKey: "parisian" },
        { value: "fr-quebec", labelKey: "quebec" },
        { value: "fr-standard", labelKey: "standard" },
        { value: "fr-swiss", labelKey: "swiss" },
    ],
    pt: [
        { value: "pt-brazilian", labelKey: "brazilian" },
        { value: "pt-european", labelKey: "european" },
        { value: "pt-african", labelKey: "africanPortuguese" },
        { value: "pt-azorean", labelKey: "azorean" },
        { value: "pt-creole", labelKey: "creolePortuguese" },
        { value: "pt-galician", labelKey: "galician" },
        { value: "pt-madeiran", labelKey: "madeiran" },
    ],
    ru: [
        { value: "ru-moscow", labelKey: "moscow" },
        { value: "ru-saint-petersburg", labelKey: "saintPetersburg" },
        { value: "ru-standard", labelKey: "standardRussian" },
    ],
    nl: [
        { value: "nl-brabantian", labelKey: "brabantian" },
        { value: "nl-flemish", labelKey: "flemish" },
        { value: "nl-gronings", labelKey: "gronings" },
        { value: "nl-limburgish", labelKey: "limburgish" },
        { value: "nl-standard", labelKey: "standardDutch" },
    ],
    it: [
        { value: "it-calabrese", labelKey: "calabrese" },
        { value: "it-florentine", labelKey: "florentine" },
        { value: "it-genoese", labelKey: "genoese" },
        { value: "it-milanese", labelKey: "milanese" },
        { value: "it-neapolitan", labelKey: "neapolitan" },
        { value: "it-romanesco", labelKey: "romanesco" },
        { value: "it-sicilian", labelKey: "sicilian" },
        { value: "it-standard", labelKey: "standardItalian" },
        { value: "it-ticinese", labelKey: "ticinese" },
        { value: "it-tuscan", labelKey: "tuscan" },
        { value: "it-venetian", labelKey: "venetian" },
    ],
    de: [
        { value: "de-bavarian", labelKey: "bavarian" },
        { value: "de-berlinerisch", labelKey: "berlinerisch" },
        { value: "de-rhine-franconian", labelKey: "rhineFranconian" },
        { value: "de-saxon", labelKey: "saxon" },
        { value: "de-standard", labelKey: "standardGerman" },
        { value: "de-swabian", labelKey: "swabian" },
    ],
    es: [
        { value: "es-latin-american", labelKey: "latinAmerican" },
        { value: "es-peninsular", labelKey: "peninsular" },
        { value: "es-andalusian", labelKey: "andalusian" },
        { value: "es-argentine", labelKey: "argentine" },
        { value: "es-basque", labelKey: "basque" },
        { value: "es-canary-islands", labelKey: "canaryIslands" },
        { value: "es-caribbean", labelKey: "caribbean" },
        { value: "es-chilean", labelKey: "chilean" },
        { value: "es-colombian", labelKey: "colombian" },
        { value: "es-cuban", labelKey: "cuban" },
        { value: "es-dominican", labelKey: "dominican" },
        { value: "es-ecuadorian", labelKey: "ecuadorian" },
        { value: "es-galician", labelKey: "galicianSpanish" },
        { value: "es-mexican", labelKey: "mexican" },
        { value: "es-peruvian", labelKey: "peruvian" },
        { value: "es-puerto-rican", labelKey: "puertoRican" },
        { value: "es-venezuelan", labelKey: "venezuelan" },
    ],
    cn: [
        { value: "zh-guangzhou-cantonese", labelKey: "cantoneseGuangzhou" },
        { value: "zh-hong-kong-cantonese", labelKey: "cantoneseHongKong" },
        { value: "zh-singapore-cantonese", labelKey: "cantoneseSingapore" },
        { value: "zh-beijing-mandarin", labelKey: "mandarinBeijing" },
        { value: "zh-singapore-mandarin", labelKey: "mandarinSingapore" },
        { value: "zh-taiwan-mandarin", labelKey: "mandarinTaiwan" },
        { value: "zh-standard", labelKey: "standardChinese" },
    ],
    kr: [
        { value: "ko-chungcheong", labelKey: "chungcheong" },
        { value: "ko-gyeongsang", labelKey: "gyeongsang" },
        { value: "ko-hamgyong", labelKey: "hamgyong" },
        { value: "ko-jeolla", labelKey: "jeolla" },
        { value: "ko-seoul", labelKey: "seoul" },
        { value: "ko-standard", labelKey: "standardKorean" },
    ],
    jp: [
        { value: "ja-kansai", labelKey: "kansai" },
        { value: "ja-kanto", labelKey: "kanto" },
        { value: "ja-kyushu", labelKey: "kyushu" },
        { value: "ja-okinawa", labelKey: "okinawa" },
        { value: "ja-standard", labelKey: "standardJapanese" },
        { value: "ja-tohoku", labelKey: "tohoku" },
    ],
    ar: [
        { value: "ar-modern-standard", labelKey: "modernStandardArabic" },
        { value: "ar-egyptian", labelKey: "egyptianArabic" },
        { value: "ar-gulf", labelKey: "gulfArabic" },
        { value: "ar-levantine", labelKey: "levantineArabic" },
        { value: "ar-bahraini", labelKey: "bahrainiArabic" },
        { value: "ar-kuwaiti", labelKey: "kuwaitiArabic" },
        { value: "ar-omani", labelKey: "omaniArabic" },
        { value: "ar-qatari", labelKey: "qatariArabic" },
        { value: "ar-saudi", labelKey: "saudiArabic" },
        { value: "ar-iraqi", labelKey: "iraqiArabic" },
        { value: "ar-jordanian", labelKey: "jordanianArabic" },
        { value: "ar-palestinian", labelKey: "palestinianArabic" },
        { value: "ar-syrian", labelKey: "syrianArabic" },
        { value: "ar-algerian", labelKey: "algerianArabic" },
        { value: "ar-moroccan", labelKey: "moroccanArabic" },
        { value: "ar-tunisian", labelKey: "tunisianArabic" },
        { value: "ar-libyan", labelKey: "libyanArabic" },
        { value: "ar-sudanese", labelKey: "sudaneseArabic" },
    ],
    pl: [
        { value: "pl-kashubian", labelKey: "kashubian" },
        { value: "pl-mazovian", labelKey: "mazovian" },
        { value: "pl-podhale", labelKey: "podhale" },
        { value: "pl-silesian", labelKey: "silesian" },
        { value: "pl-standard", labelKey: "standardPolish" },
    ],
    da: [
        { value: "da-copenhagen", labelKey: "copenhagen" },
        { value: "da-jutlandic", labelKey: "jutlandic" },
        { value: "da-standard", labelKey: "standardDanish" },
        { value: "da-zealandic", labelKey: "zealandic" },
    ],
    he: [{ value: "he-standard", labelKey: "standardHebrew" }],
    no: [
        { value: "no-standard", labelKey: "standardNorwegian" },
        { value: "no-oslo", labelKey: "oslo" },
        { value: "no-bergen", labelKey: "bergen" },
        { value: "no-trondersk", labelKey: "trondersk" },
        { value: "no-northern", labelKey: "northernNorwegian" },
        { value: "no-sorlandsk", labelKey: "sorlandsk" },
    ],
    sv: [
        { value: "sv-gothenburg", labelKey: "gothenburg" },
        { value: "sv-gotland", labelKey: "gotland" },
        { value: "sv-norrland", labelKey: "norrland" },
        { value: "sv-scanian", labelKey: "scanian" },
        { value: "sv-standard", labelKey: "standardSwedish" },
        { value: "sv-stockholm", labelKey: "stockholm" },
    ],
    gr: [
        { value: "el-aegean", labelKey: "aegean" },
        { value: "el-athenian", labelKey: "athenian" },
        { value: "el-cretan", labelKey: "cretan" },
        { value: "el-cypriot", labelKey: "cypriot" },
        { value: "el-macedonian", labelKey: "macedonianGreek" },
        { value: "el-pontic", labelKey: "pontic" },
        { value: "el-standard", labelKey: "standardGreek" },
    ],
};

export const AGE_OPTIONS = [
    { value: "young", labelKey: "young" },
    { value: "middle-aged", labelKey: "middleAged" },
    { value: "old", labelKey: "old" },
];
